import { CUSTOM_FIELD_TYPES } from '@webapp-next/modules/schedule/definitions';

const VueDefinitions = {
  CUSTOM_FIELD_TYPES,
};

export default VueDefinitions;
